import React, { Component } from 'react';
import {connect} from 'react-redux';

import {fetchLoanPlans} from '../loanPlanActions';

import Layout from '../../shared/components/layouts/MainLayout';
import LoanPlanItems from '../components/LoanPlanItems';
import EmptyState from '../components/EmptyState';

import {segmentEventTracker} from '../../../utils/SegmentEventTracker';
import {
  PageViewName,
  TrackEventName,
} from '../../shared/constants/SegmentEvents';

class LoanPlans extends Component {
  componentDidMount() {
    this.props.fetchLoanPlans(this.props.user.id);
    segmentEventTracker.trackPageView(PageViewName.LOANS_VIEWED);
  }

  onClickLoanPlanItem = () => {
    segmentEventTracker.trackEvent(TrackEventName.LOAN_VIEW_DETAILS_CLICKED);
  };

  render() {
    const {pending, active} = this.props;
    if (this.props.loading)
      return (
        <Layout>
          <div className="loading" />
        </Layout>
      );

    if (pending.length === 0 && active.length === 0) {
      return (
        <Layout gridClassName="--narrow">
          <EmptyState type="active loans" />
        </Layout>
      );
    }

    return (
      <Layout gridClassName="--narrow">
        <LoanPlanItems
          loans={pending}
          caption="active loans"
          onClickLoanPlan={this.onClickLoanPlanItem}
        />
        <LoanPlanItems
          loans={active}
          caption="repaid loans"
          onClickLoanPlan={this.onClickLoanPlanItem}
        />
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    active: state.loans.active,
    pending: state.loans.pending,
    loading: state.shared.ui.loading.default,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    fetchLoanPlans: id => dispatch(fetchLoanPlans(id)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LoanPlans);



// WEBPACK FOOTER //
// ./src/features/loans/containers/LoanPlans.js